import downpin from "./downpin.svg";

export default function PinIcon() {
  return (
    <img src={downpin} />
  );
}